import React from "react";
import { Heading } from "../../../design/heading";
import { Card } from "../../../design/card";
import { Text } from "../../../design/text";
import moment from "moment";
import { useCustodyEvent } from "../../../contexts/CustodyEventContext";
import { useMatter } from "../../../contexts/MatterContext";
import { useVisitationSchedule } from "../../../contexts/VisitationScheduleContext";
import { useNavigate } from "react-router-dom";
import HolidayScheduleButton from "../../../components/HolidayScheduleButton";
import { useHolidaySchedule } from "../../../contexts/HolidayScheduleContext";

interface Props {}

const NextHolidayComponent: React.FC<Props> = ({}) => {
  const { partiesInvolved } = useMatter();
  const { custodyEvents } = useCustodyEvent();
  const { currentHolidaySchedule } = useHolidaySchedule();
  const navigate = useNavigate();

  const upcomingHoliday = custodyEvents
    .filter((event) => event.eventType === "holiday")
    .filter((event) => {
      const start = moment(`${event.startDate}T${event.startTime}`);
      return start.isAfter(moment());
    })
    .sort((a, b) => {
      const aStart = moment(`${a.startDate}T${a.startTime}`);
      const bStart = moment(`${b.startDate}T${b.startTime}`);
      return aStart.diff(bStart);
    })[0];

  if (!currentHolidaySchedule) {
    return (
      <Card>
        <Heading level={5}>Upcoming Holiday</Heading>
        <Text>No holidy schedule available.</Text>
        <HolidayScheduleButton
          onSave={(id) => navigate(`/holiday-schedule/${id}`)}
        />
      </Card>
    );
  }

  if (!upcomingHoliday) {
    return (
      <Card>
        <Heading level={5}>Upcoming Holiday</Heading>
        <Text>No upcoming holidays found.</Text>
      </Card>
    );
  }

  return (
    <Card>
      <Heading level={5}>Upcoming Holiday</Heading>
      <Text>
        {upcomingHoliday?.title} - {upcomingHoliday?.startDate}
      </Text>
      <Text className="text-sm text-gray-500">
        With:{" "}
        {
          partiesInvolved.find((p) => p._id === upcomingHoliday?.participantId)
            ?.name
        }
      </Text>
    </Card>
  );
};

export default NextHolidayComponent;
